const Document = ({ filename, availableDocuments }) => {
  const filepath = availableDocuments[filename]
  const HTML = require(`./${filepath}`)

  return (
    <div
      className='Document'
      dangerouslySetInnerHTML={{ __html: HTML.default }}
    />
  )
}

export default Document
